export default __webpack_public_path__ + "static/media/regulatory--stop--g9.06825e07.png";